import {
  PAYMENT_POPUP_SET_ACH_INFO,
  PAYMENT_POPUP_SET_BILLING_INFO,
  PAYMENT_POPUP_SET_CARD_INFO,
  PAYMENT_POPUP_SET_PAYMENT_AMOUNT,
  PAYMENT_POPUP_SET_PAYMENT_ERRORS, PAYMENT_POPUP_SET_PAYMENT_STATUS,
  PAYMENT_POPUP_SET_PAYMENT_STEP,
  PAYMENT_POPUP_SET_PAYMENT_TYPE,
  PAYMENT_POPUP_SET_REFUND_TRANSACTION_ID, PAYMENT_POPUP_SET_REFUND_TRANSACTION_STATUS,
  PAYMENT_POPUP_SET_USE_CUSTOM_AMOUNT
} from "../../../constants/actionTypes";
import Misc from "../../../misc";

export const setJobPaymentType = (paymentType) => ({
  type: PAYMENT_POPUP_SET_PAYMENT_TYPE,
  payload: {paymentType}
})

export const setJobPaymentStep = (paymentStep) => ({
  type: PAYMENT_POPUP_SET_PAYMENT_STEP,
  payload: {paymentStep}
})

const getAmountsPayload = (jobTotal, useCustomAmount, customAmount, percentageAmount) => {
  const payload = {
    paymentTotal: 0,
  }
  if (useCustomAmount) {
    payload.paymentTotal = customAmount;
    payload.customAmount = customAmount;
    payload.percentageAmount = ((customAmount / jobTotal) * 100).toFixed(4);
  } else {
    const notRounded = Misc.percentage(jobTotal, percentageAmount);
    const paymentTotal = (Math.round(notRounded * 100) / 100).toFixed(2);
    payload.paymentTotal = paymentTotal;
    payload.percentageAmount = percentageAmount;
    payload.customAmount = paymentTotal;
  }
  return payload
}

export const setJobPaymentUseCustomAmount = (useCustomAmount) => {
  return (dispatch, getState) => {
    const {jobTotal, customAmount, percentageAmount} = getState().jobPaymentState;
    const payload = getAmountsPayload(jobTotal, useCustomAmount, customAmount, percentageAmount)
    dispatch({
      type: PAYMENT_POPUP_SET_USE_CUSTOM_AMOUNT,
      payload: {
        useCustomAmount,
        paymentTotal: payload.paymentTotal,
      }
    });
  }
}

export const setJobPaymentAmount = (value) => {
  return (dispatch, getState) => {
    const {jobTotal, useCustomAmount, customAmount, percentageAmount} = getState().jobPaymentState;

    dispatch({
      type: PAYMENT_POPUP_SET_PAYMENT_AMOUNT,
      payload: getAmountsPayload(
        jobTotal,
        useCustomAmount,
        useCustomAmount ? value : customAmount,
        useCustomAmount ? percentageAmount : value
      )
    });
  }
}

export const setPaymentInputValue = (propObject) => {
  switch (Object.keys(propObject)[0]) {
    case "accountNumber":
    case "routingNumber":
      return {
        type: PAYMENT_POPUP_SET_ACH_INFO,
        payload: propObject
      }
    case "cardNumber":
    case "cardExpiry":
    case "cardExpiryMonth":
    case "cardExpiryYear":
    case "cardCvv":
      return {
        type: PAYMENT_POPUP_SET_CARD_INFO,
        payload: propObject
      }
    default:
      return {
        type: PAYMENT_POPUP_SET_BILLING_INFO,
        payload: propObject
      }
  }
}

export const setJobPaymentErrors = (paymentErrors) => ({
  type: PAYMENT_POPUP_SET_PAYMENT_ERRORS,
  payload: paymentErrors
})

export const setJobPaymentStatus = (paymentStatus) => ({
  type: PAYMENT_POPUP_SET_PAYMENT_STATUS,
  payload: {paymentStatus}
})

export const setJobPaymentRefundTransactionId = (refundTransactionId) => ({
  type: PAYMENT_POPUP_SET_REFUND_TRANSACTION_ID,
  payload: {refundTransactionId}
})

export const setJobPaymentRefundTransactionStatus = (refundTransactionStatus) => ({
  type: PAYMENT_POPUP_SET_REFUND_TRANSACTION_STATUS,
  payload: {refundTransactionStatus}
})
